import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ResultsHeader = ({ missionResult, onRetry, onNextMission, onBackToMap }) => {
  const getStatusIcon = () => {
    switch (missionResult?.status) {
      case 'passed':
        return { name: 'CheckCircle', color: 'var(--color-success)' };
      case 'failed':
        return { name: 'XCircle', color: 'var(--color-error)' };
      case 'partial':
        return { name: 'AlertCircle', color: 'var(--color-warning)' };
      default:
        return { name: 'Clock', color: 'var(--color-muted-foreground)' };
    }
  };

  const statusIcon = getStatusIcon();

  return (
    <div className="bg-card rounded-lg p-6 border border-subtle">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        {/* Status and Mission Info */}
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className={`w-16 h-16 rounded-full flex items-center justify-center ${
              missionResult?.status === 'passed' ? 'bg-success/20' :
              missionResult?.status === 'failed'? 'bg-error/20' : 'bg-warning/20'
            }`}>
              <Icon name={statusIcon?.name} size={32} color={statusIcon?.color} />
            </div>
          </div>
          
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h1 className="text-2xl font-bold text-foreground">
                {missionResult?.missionTitle}
              </h1>
              <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                missionResult?.difficulty === 'Beginner' ? 'bg-success/20 text-success' :
                missionResult?.difficulty === 'Intermediate'? 'bg-warning/20 text-warning' : 'bg-error/20 text-error'
              }`}>
                {missionResult?.difficulty}
              </span>
            </div>
            
            <div className="flex items-center gap-6 text-sm text-muted-foreground mb-3">
              <div className="flex items-center gap-2">
                <Icon name="Clock" size={16} />
                <span>Completed: {missionResult?.completedAt}</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Timer" size={16} />
                <span>Duration: {missionResult?.executionTime}</span>
              </div>
            </div>
            
            <div className="flex items-center gap-4">
              <div className="text-3xl font-bold text-foreground">
                {missionResult?.score}%
              </div>
              <div className="flex-1 max-w-xs">
                <div className="w-full h-3 bg-muted rounded-full overflow-hidden">
                  <div 
                    className={`h-full transition-all duration-500 ${
                      missionResult?.score >= 80 ? 'bg-success' :
                      missionResult?.score >= 60 ? 'bg-warning': 'bg-error'
                    }`}
                    style={{ width: `${missionResult?.score}%` }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 lg:flex-col xl:flex-row">
          <Button
            variant="outline"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onRetry}
            className="flex-1 sm:flex-none"
          >
            Retry Mission
          </Button>
          
          {missionResult?.status === 'passed' && (
            <Button
              variant="default"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={onNextMission}
              className="flex-1 sm:flex-none"
            >
              Next Mission
            </Button>
          )}
          
          <Button
            variant="ghost"
            iconName="Map"
            iconPosition="left"
            onClick={onBackToMap}
            className="flex-1 sm:flex-none"
          >
            Mission Map
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResultsHeader;